import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { PHILOSOPHY } from "../../data/content";

export const Philosophy = () => {
  return (
    <Section id="philosophy" glow>
      <SectionHeading overline={PHILOSOPHY.overline} title={PHILOSOPHY.title} intro={PHILOSOPHY.intro} />

      <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-10">
        {PHILOSOPHY.chapters.map((ch, i) => (
          <Reveal
            key={ch.no}
            delay={i * 0.1}
            className={`relative ${i === 0 ? "md:col-span-7" : "md:col-span-5 md:mt-24"}`}
          >
            <div className="relative rounded-3xl border border-white/5 bg-white/[0.015] p-8 md:p-12 overflow-hidden group">
              <span className="pointer-events-none absolute -top-10 right-4 font-heading text-8xl md:text-9xl font-light text-white/[0.04] select-none">
                {ch.no}
              </span>
              <div className="font-mono text-xs uppercase tracking-[0.22em] text-brand mb-6">
                Chapter {ch.no} — {ch.key}
              </div>
              <h3 className="font-heading text-2xl md:text-3xl font-medium tracking-tight text-white max-w-md">
                {ch.title}
              </h3>
              <p className="mt-5 text-base md:text-lg leading-relaxed text-muted-foreground max-w-md">
                {ch.body}
              </p>
              <div className="pointer-events-none absolute inset-0 rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 ring-1 ring-inset ring-brand/20" />
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-16 font-heading text-2xl sm:text-3xl md:text-4xl font-light tracking-tight text-white/90 max-w-2xl">
          <span className="text-brand">→</span> {PHILOSOPHY.closing}
        </p>
      </Reveal>
    </Section>
  );
};

export default Philosophy;
